// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gvuW","rootMobile":"styles_rootMobile__2C72F"};